export enum CUSTOMER_TYPES {
  COMPANY_GROUP = 'C',
  INDIVIDUAL = 'I',
}

export enum CUSTOMER_CREATED_TYPE {
  MANUAL = 'M',
  AUTO = 'A',
}

export enum SINGLE_OR_BULK {
  SINGLE = 'S',
  BULK = 'B',
}

export enum BULK_REQUEST_FIELDS_CUSTOMER_STEP {
  UNIQUE_BULK_REQUEST_NUMBER = 'Unique Bulk Request Number',
  GROUP_OR_INDIVIDUAL = 'Group Or Individual',
  SALUTATION = 'Salutation',
  NAME = 'Name',
  NIC_OR_BRN = 'Nic Or Brn',
  EMAIL = 'Email',
  CONTACT_NUMBER = 'Contact Number',
  VEHICLE_NUMBER = 'Vehicle Number',
  COUNTRY = 'Country',
  STATE = 'State',
  DISTRICT = 'District',
  CITY = 'City',
  ADDRESS = 'Address',
  ACCOUNT_HANDLER = 'Account Handler',
  SOURCE_OF_LEAD = 'Source Of Lead',
  AGENT_CODE = 'Agent Code',
  AGENT_AMOUNT = 'Agent Commission Amount',
  EXTERNAL_AGENT_CODE = 'External Agent Code',
  EXTERNAL_AGENT_RATE = 'External Agent Rate',
  EXTERNAL_AGENT_AAMOUNT = 'External Agent Amount',
  ADDITIONAL_AGENT_CODE = 'Additional Agent Code',
  COMMISSION_AMOUNT = 'Commission Amount',
  CLAIM_HANDLER = 'Claim Handler',
}

export enum BULK_REQUEST_INSURANCE_FIELDS {
  INSURANCE_TYPE = 'Insurance Type',
  CLASS_IF_GENERAL = 'Class If General',
  PRODUCT = 'Product',
  INSURER = 'Insurer',
  SCHEMES = 'Schemes',
  COVERAGE = 'Coverage',
  COUNT = 'Count',
  COVER = 'Cover',
  COVER_SUM_ASSURED = 'Cover Sum Assured',
}

export enum CUSTOMERS_STEP_BULK_FIELDS {
  TYPE = 'Type (Credit/ Debit)',
  TRANSACTION_TYPE = 'Transaction Type',
  VAT_SVAT = 'Vat/ Svat',
  POLICY_TYPE = 'Policy Type (Local/ Fronting)',
  POLICY_NUMBER = 'Policy Number',
  POLICY_START_DATE = 'Policy Start Date',
  POLICY_END_DATE = 'Policy End Date',
  CUSTOMERS_NUMBER = 'Invoice Number',
  DATE_OF_ISSUE = 'Date Of Issue',
  TYPE_OF_PRODUCT = 'Type Of Product',
  CURRENCY_TYPE = 'Currency Type',
  CONVERSION_RATE = 'Conversion Rate',
  PAID_DATE = 'Paid Date',
  PAID_CONVERSION_RATE = 'Paid Conversion Rate',
}

export enum CUSTOMERS_PREMIUM_BULK_FIELDS {
  SUM_ASSURED = 'Sum Assured',
  BASIC = 'Basic',
  SRCC = 'Srcc',
  TC = 'Tc',
  DISCOUNT = 'Discount',
}

export enum CUSTOMERS_COMMISSION_BULK_FILDS {
  TOTAL_PREMIUM = 'Total Premium',
  COMMISSION_TYPE = 'Commission Type',
  COMMISSION_BASIC = 'Commission For Basic',
  COMMISSION_SRCC = 'Commission For SRCC',
  COMMISSION_TC = 'Commission For TC',
  FEE = 'Fee',
  TOTAL_RECEIVABLE_COMMISSION = 'Total Receivable / Refundable Commission',
  COMMISSION_RECEIVED = 'Commission Received Amount',
  COMMISSION_RECEIVED_DATE = 'Commission Received Date',
}

export enum CUSTOMERS_RECEIPT_BULK_FILDS {
  RECEIPT_PAID_AMOUNT = 'Receipt Paid Amount',
  RECEIPT_PAID_DATE = 'Receipt Paid Date',
  RECEIPT_PAY_TO = 'Receipt Pay To',
}

export enum CUSTOMER_OPTIONAL_PREVIOUS {
  PREVIOUS_POLICY_NUMBER = 'Previous Policy Number',
  PREVIOUS_POLICY_YEAR = 'Previous Policy Year',
}

export enum CUSTOMER_BULK_STEP {
  CUSTOMER = 'C',
  PRODUCT = 'P',
  INVOICE = 'I',
}
